import React from 'react';
import global from '../../../styles/index.module.scss';
import styles from './StepHeader.module.scss';

interface StepHeaderProps {
  stepNumber: number;
  title: React.ReactNode;
  subtitle?: string;
  firstcollectionhandle?: string;
}

export const StepHeader: React.FC<StepHeaderProps> = ({ stepNumber, title, subtitle, firstcollectionhandle }) => {
  return (
    <div className={styles.stepHeader}>
      {firstcollectionhandle !== 'suits_campaign' && (
        <div className={global.label}>STEP{stepNumber}</div>
      )}
      <h2 className={styles.heading2}>{title}</h2>
      {subtitle && <p className={styles.subtitle}>{subtitle}</p>}
    </div>
  );
};